import { format } from "date-fns";
import { formatPeriodRange } from "@/lib/invoices/invoice-subject";

export const BILLING_TIME_ZONE = "America/New_York";

export interface BillingPeriodOverview {
  currentLabel: string;
  currentRange: string;
  nextInvoiceDate: string;
}

function getBillingMonth(now: Date): { year: number; monthIndex: number } {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: BILLING_TIME_ZONE,
    year: "numeric",
    month: "numeric",
  }).formatToParts(now);
  const year = Number(parts.find((part) => part.type === "year")?.value);
  const month = Number(parts.find((part) => part.type === "month")?.value);

  if (!Number.isInteger(year) || !Number.isInteger(month)) {
    throw new Error("Unable to resolve the billing calendar month");
  }
  return { year, monthIndex: month - 1 };
}

/** Calendar values shown by the app, aligned with the generator's New York billing date. */
export function getBillingPeriodOverview(now: Date = new Date()): BillingPeriodOverview {
  const { year, monthIndex } = getBillingMonth(now);
  const periodStart = new Date(year, monthIndex, 1);
  const periodEnd = new Date(year, monthIndex + 1, 0);
  const nextInvoice = new Date(year, monthIndex + 1, 3);

  return {
    currentLabel: format(periodStart, "MMM yyyy"),
    currentRange:
      formatPeriodRange(format(periodStart, "yyyy-MM-dd"), format(periodEnd, "yyyy-MM-dd")) ?? "—",
    nextInvoiceDate: format(nextInvoice, "MMM d, yyyy"),
  };
}
